export default function ProductHero() {
  return (
    <section className="relative min-h-[680px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20technician%20in%20dark%20uniform%20installing%20ELCO%20heat%20pump%20outdoor%20unit%20modern%20Swiss%20villa%20Geneva%20dramatic%20industrial%20lighting%20precision%20work%20tools%20energy%20efficient%20heating%20system%20installation&width=1920&height=700&seq=pac-hero-v2-bg&orientation=landscape"
          alt="Installation pompe à chaleur ELCO à Genève"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950/95 via-gray-950/75 to-gray-950/30"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-7xl px-6 lg:px-8 py-28">
        <div className="max-w-2xl">
          {/* Badge univers */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-amber-500/20 border border-amber-500/40">
              <i className="ri-tools-line text-amber-400 text-sm"></i>
            </div>
            <span className="text-xs font-bold tracking-widest uppercase text-amber-400">Univers Technique · HB Services</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-white mb-6 leading-tight">
            Pompes à chaleur<br />
            <span className="text-amber-400">ELCO haut de gamme</span>
          </h1>
          <p className="text-lg text-white/70 leading-relaxed mb-10 max-w-xl">
            Leader suisse depuis 1928. Solutions air-eau et géothermiques pour tous types de bâtiments. Installation certifiée, subventions cantonales disponibles.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#produits" className="inline-flex items-center justify-center gap-2 rounded-lg bg-amber-500 px-7 py-3.5 text-sm font-semibold text-white hover:bg-amber-600 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-temp-hot-line"></i>
              Voir les modèles ELCO
            </a>
            <a href="#contact" className="inline-flex items-center justify-center gap-2 rounded-lg bg-white/8 backdrop-blur-sm px-7 py-3.5 text-sm font-semibold text-white border border-white/20 hover:bg-white/15 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-mail-send-line"></i>
              Devis gratuit
            </a>
          </div>

          {/* Stats */}
          <div className="mt-14 flex flex-wrap gap-10">
            {[
              { value: 'COP 5.2', label: 'Rendement max' },
              { value: '-70%', label: 'Empreinte carbone' },
              { value: '7 ans', label: 'Garantie constructeur' },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-2xl font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/45 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Badges flottants */}
      <div className="absolute bottom-8 right-8 hidden lg:flex flex-col gap-3">
        {[
          { icon: 'ri-leaf-line', text: 'Fluide R32 écologique' },
          { icon: 'ri-money-euro-circle-line', text: 'Subventions cantonales' },
          { icon: 'ri-shield-check-line', text: 'Techniciens certifiés ELCO' },
        ].map((b, i) => (
          <div key={i} className="flex items-center gap-2.5 bg-white/8 backdrop-blur-md border border-white/15 rounded-lg px-4 py-2.5">
            <i className={`${b.icon} text-amber-400 text-sm`}></i>
            <span className="text-xs font-medium text-white/80">{b.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
